// extracted by mini-css-extract-plugin
export default {"changeLink":"PO-z","disabled":"QO-z","inline":"RO-z"};